import { useEffect, type ReactNode } from "react";
import { useLocation } from "wouter";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

// Garde de route : redirige les visiteurs anonymes vers la home,
// affiche un spinner tant que la session est en cours de resolution.
// On NE redirige PAS pendant `loading` -- sinon un utilisateur
// authentifie qui recharge une page protegee serait expulse avant que
// Supabase n'ait restaure sa session depuis le localStorage.
export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { session, loading } = useAuth();
  const [, setLocation] = useLocation();

  useEffect(() => {
    if (!loading && !session) {
      setLocation("/");
    }
  }, [loading, session, setLocation]);

  if (loading) {
    return (
      <div
        className="min-h-screen flex items-center justify-center"
        style={{ background: "oklch(0.115 0.038 243)", color: "oklch(1 0 0)" }}
      >
        <Loader2 className="animate-spin" size={28} />
      </div>
    );
  }
  if (!session) return null;
  return <>{children}</>;
}
